import { FacetValue } from './FacetValue';
import { ParameterType } from '../enums';

export class FilterFacets {
	public constructor(public readonly type: ParameterType, public readonly values: FacetValue[]) {}
}
